import { RealEstateSideBarFiltersType } from '../side-bar-filter/real-estate-side-bar-filters.type';
import appApi from '../../../../../api/app-api';
import { RealEstateReportType } from '../../../../../api/types/reports/finanace/real-estate-report.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getReportRealEstateOperation = async (
  filters: RealEstateSideBarFiltersType,
  setData: (data: RealEstateReportType[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getRealEstateReport(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    console.error(
      `getReportRealEstateOperation is failed with the filters: ${JSON.stringify(filters)} and the error: ${e}`,
    );
    setLoading(false);
  }
};
